import $ from 'jquery';
import { apiUrl } from '@/config/backend';

export default {
    state: {
        id: "",
        username: "",
        photo: "",
        token: "",
        is_login: false,
        pulling_info: true,
    },
    getters: {
    },
    mutations: {
        updateUser(state, user) {
            // console.log("调试user_id是否存在:" + user.user_id);
            state.id = user.user_id;
            state.username = user.username;
            state.photo = user.photo;
            state.is_login = user.is_login;
        },
        updateToken(state, token) {
            state.token = token;
        },
        logout(state) {
            state.id = "";
            state.username = "";
            state.photo = "";
            state.token = "";
            state.is_login = false;
        },
        updatePullingInfo(state, pulling_info) {
            state.pulling_info = pulling_info;
        }
    },
    actions: {
        login(context, data) {
            $.ajax({
                url: apiUrl("/api/user/account/token/"),
                type: "post",
                data: {
                    username: data.username,
                    password: data.password,
                },
                success(resp) {
                    // console.log("login中的em信息:" + resp.error_message);
                    if (resp.error_message === "success") {
                        localStorage.setItem("jwt_token", resp.token);
                        context.commit("updateToken", resp.token);
                        // console.log("login success"); //调试正确
                        data.success(resp);
                    } else {
                        data.error(resp);
                    }
                },
                error(resp) {
                    data.error(resp);
                }
            });
        },
        getinfo(context, data) {
            $.ajax({
                url: apiUrl("/api/user/account/info/"),
                type: "get",
                headers: {
                    Authorization: "Bearer " + context.state.token,
                },
                success(resp) {
                    //console.log(resp); //2024.01.16排出bug，后端参数错误
                    //console.log("查看返回的信息：" + resp.error_message); //resp.error_message:undefined
                    // console.log(JSON.stringify(resp, null, 2)); //格式化输出对象
                    if (resp.error_message === "success") {  // 未正确执行
                        context.commit("updateUser", {
                            ...resp,
                            is_login: true,
                        });
                        data.success(resp);
                    } else {
                        data.error(resp); //暂时不执行，bug位置
                    }
                },
                error(resp) {
                    data.error(resp);
                }
            })
        },
        logout(context) {
            localStorage.removeItem("jwt_token");
            context.commit("logout");
        }
    },
    modules: {
    }
}

